import "../styles/Footer.css"

export default function Footer() {
    return (
        <footer id="Footer" >
            <div className="legacy"><p>Minden jog fentartva az SOS Elevator Kft. számára </p></div>
            <div className="author">
                <p>Website by: Hamar Patrik</p>
                <p>email: hamar.patrik94@gmail.com</p>
            </div>
        </footer>
    )
}